import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Color, Size, Tooltip } from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import { useWindowDimensions } from 'page_modules/compare-cards/hooks/index.js';
import { getHighlightsData } from 'page_modules/compare-cards/redux/index.js';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';
import removeTagsAndTheirContent from 'service_modules/utils/text-remove-tags';
import clsx from 'clsx';

const AddToolTip = ({ text, benefitName, highlights }) => {
  const [arrowDirection, setArrowDirection] = useState('bottom');
  const [extraClass, setExtraClass] = useState('');
  const tooltipRef = useRef();
  const underscoreBenefit = removeTagsAndTheirContent(
    benefitName.split(' ').join('_')
  );
  const { height, width } = useWindowDimensions();

  const findPopupWidth = () => {
    if (width < 768) {
      return width * 0.65;
    } else {
      return 280;
    }
  };

  const [popupWidth, setPopupWidth] = useState(findPopupWidth());

  const customAriaLabel = `${removeTagsAndTheirContent(benefitName)} button`;

  const onToggle = isOpen => {
    if (isOpen) {
      const stickyHeadEle = document.querySelector(
        '[class*="purify_desktopHeader__container--"]'
      );
      setPopupWidth(findPopupWidth());
      const node = tooltipRef.current;
      let smallScreen = width < 768;
      const rect = node.getBoundingClientRect();
      const stickyHeaderHeight = smallScreen
        ? 0
        : stickyHeadEle
          ? stickyHeadEle.offsetHeight
          : 260;
      const distanceToLeftWinBorder = rect.x || rect.left;
      const distanceToRightWinBorder = width - distanceToLeftWinBorder;
      const distanceToTop = rect.bottom;
      const viewerHeight = height - stickyHeaderHeight;
      const middlePoint = width * 0.5;
      const distanceToMiddlePoint =
        middlePoint > distanceToLeftWinBorder
          ? middlePoint - distanceToLeftWinBorder
          : middlePoint - distanceToRightWinBorder;

      if (smallScreen && distanceToRightWinBorder < 150) {
        setPopupWidth((width - distanceToRightWinBorder) * 0.95);
        setArrowDirection('left');
        if (distanceToTop > viewerHeight) {
          setExtraClass('bottom-left');
        } else {
          setExtraClass('');
        }
      } else if (smallScreen && distanceToLeftWinBorder < 75) {
        setArrowDirection('right');
      } else if (distanceToTop > viewerHeight) {
        setArrowDirection('top');
        if (smallScreen) {
          setPopupWidth((width - distanceToMiddlePoint) * 0.78);
        }
      } else {
        setArrowDirection('bottom');
        if (smallScreen) {
          setPopupWidth((width - distanceToMiddlePoint) * 0.78);
        }
      }
    }
    sendDTMClickEvent({
      ...highlights.tooltipDtm,
      eventAsset: replaceStringWithVars({
        varsObject: {
          benefitName: underscoreBenefit
        },
        string: highlights?.tooltipDtm?.eventAsset ?? ''
      })
    });
  };

  return (
    <div ref={tooltipRef} className={clsx(`${arrowDirection}-tooltip`, extraClass)}>
      <Tooltip
        $direction={arrowDirection}
        $maxWidth={popupWidth}
        customization={{
          tooltip: {
            bgColor: Color.White,
            rounded: Size.SM
          },
          tooltipText: {
            color: Color.Black
          },
          dynamicAriaLabel: customAriaLabel
        }}
        data={{
          content: <Sanitizer safelySetInnerHTML={text} />
        }}
        onToggle={onToggle}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    highlights: getHighlightsData(state)
  };
};

export default connect(mapStateToProps)(AddToolTip);
